/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationUsersResponseData,
  GetOrganizationUsersResponseDataFromJSON,
  GetOrganizationUsersResponseDataFromJSONTyped,
  GetOrganizationUsersResponseDataToJSON
} from './GetOrganizationUsersResponseData'

/**
 *
 * @export
 * @interface GetSettableDocumentOpportunityUsersResponse
 */
export interface GetSettableDocumentOpportunityUsersResponse {
  /**
   *
   * @type {number}
   * @memberof GetSettableDocumentOpportunityUsersResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationUsersResponseData}
   * @memberof GetSettableDocumentOpportunityUsersResponse
   */
  data?: GetOrganizationUsersResponseData
}

export function GetSettableDocumentOpportunityUsersResponseFromJSON(
  json: any
): GetSettableDocumentOpportunityUsersResponse {
  return GetSettableDocumentOpportunityUsersResponseFromJSONTyped(json, false)
}

export function GetSettableDocumentOpportunityUsersResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSettableDocumentOpportunityUsersResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationUsersResponseDataFromJSON(json['data'])
  }
}

export function GetSettableDocumentOpportunityUsersResponseToJSON(
  value?: GetSettableDocumentOpportunityUsersResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationUsersResponseDataToJSON(value.data)
  }
}
